import React, { useCallback, useEffect, useState } from 'react';
import { Card, Col, Row, Tag } from 'antd';
import { colorsLight } from '../../../assets/colors/light';
import Info3 from '../../../assets/icons/info_3.svg';
import Info11 from '../../../assets/icons/info_11.svg';
import Info12 from '../../../assets/icons/info_12.svg';
import Info5 from '../../../assets/icons/info_5.svg';
import Info6 from '../../../assets/icons/info_6.svg';
import Info7 from '../../../assets/icons/info_7.svg';
import MapOfCameraComponent from '../../Dashboard/MapOfCamera';
import { Axios } from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import * as SERVICE from '../../../constants/service.types';
import { socketEmitEvent } from '../../../redux/actions';
import './index.scss';

const DeviceInfoCard = ({ selectedStream, t }) => {
  const [keyMap, setKeyMap] = useState(Math.random());
  const dispatch = useDispatch();
  const [keyMapMode, setKeyMapMode] = useState(Math.random());
  const { namespace, gatewayStates, public_ip, listDeviceContact } =
    useSelector((state) => state);
  const [ipAddress, setIpAddress] = useState();
  const [internalGateways, setInternalGateways] = useState([]);
  const [localMarker, setLocalMarker] = useState();

  useEffect(() => {
    if (public_ip) {
      setIpAddress(public_ip);
    }
  }, [public_ip]);

  useEffect(() => {
    if (listDeviceContact) {
      setLocalMarker({
        lat: listDeviceContact.lat,
        lng: listDeviceContact.lng,
      });
    }
  }, [listDeviceContact]);

  useEffect(() => {
    async function getInternalGateway(link, serial) {
      try {
        let result = await Axios.get(link);
        return result.status === 200 && result.data.serial === serial;
      } catch (error) {
        console.log('ERROR', error);
        return false;
      }
    }
    if (gatewayStates && ipAddress) {
      setInternalGateways(
        gatewayStates.data.filter((gateway) => {
          if (
            ipAddress &&
            gateway.state === 1 &&
            gateway.ipAddress &&
            gateway.ipAddress === ipAddress &&
            gateway.localAddress &&
            gateway.localAddress.length > 0
          ) {
            return getInternalGateway(
              `http://${gateway.localAddress}:${gateway.portScan}/info`,
              gateway.serial
            );
          }
          return false;
        })
      );
    }
  }, [gatewayStates, ipAddress]);

  const getDeviceStatesMap = useCallback(
    (deviceSerials) => {
      let data = {
        namespace,
        serials: deviceSerials.join(';'),
      };

      let dataObj = {
        appServiceType: SERVICE.LIST_STATE_DEVICES,
        requestId: 1646116091999,
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace]
  );

  return (
    <Card
      style={{
        height: '100%',
      }}
      headStyle={{
        minHeight: 30,
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '10px',
        }}
      >
        <span style={{ fontWeight: 600 }}>{selectedStream?.name}</span>
        {listDeviceContact?.state === 1 ? (
          <Tag color={colorsLight.$online}>Online</Tag>
        ) : (
          <Tag color={colorsLight.$offline}>Offline</Tag>
        )}
      </div>

      {selectedStream && (
        <div key={keyMapMode} flex="auto" className="device-playback-map">
          <MapOfCameraComponent
            localMarker={localMarker}
            key={keyMap}
            internalGateways={internalGateways}
            cameras={[selectedStream]}
            getDeviceStatesMap={getDeviceStatesMap}
            setKeyMap={setKeyMap}
            mode={0}
          />
        </div>
      )}

      {listDeviceContact?.note && (
        <div className="info-block">
          <img
            className="info-icon-stream --playback"
            alt="live-stream-icon"
            src={Info3}
          />
          {listDeviceContact?.note || ''}
        </div>
      )}
      {listDeviceContact?.state === 0 && (
        <div span={24}>
          <Row>
            {listDeviceContact?.errorTime && (
              <Col
                span={24}
                style={{
                  marginTop: '5px',
                  fontSize: '13px',
                }}
              >
                <img
                  className="info-icon-stream --playback"
                  alt="live-stream-icon"
                  src={Info11}
                />
                {t('Time')}:{' '}
                <span style={{ color: 'rgb(245, 47, 57)' }}>
                  {listDeviceContact?.errorTime || ''}
                </span>
              </Col>
            )}
            {listDeviceContact?.errorMessage && (
              <Col
                span={24}
                style={{
                  color: 'hsla(0, 0%, 100%, 0.65)',
                  marginTop: '5px',
                  fontSize: '13px',
                }}
              >
                <img
                  className="info-icon-stream --playback"
                  alt="live-stream-icon"
                  src={Info12}
                />
                {t('Reason')}:{' '}
                <span style={{ color: 'rgb(245, 47, 57)' }}>
                  {listDeviceContact?.errorMessage || ''}
                </span>
              </Col>
            )}
          </Row>
        </div>
      )}
      <div className="info-block" style={{ fontSize: '13px' }}>
        <img
          className="info-icon-stream --playback"
          alt="live-stream-icon"
          src={Info5}
        />
        <span style={{ color: '#1757B7' }}>{t('PERSON IN CHARGE')}</span>
      </div>
      {listDeviceContact?.assigners?.length > 0 &&
        listDeviceContact.assigners.map((item, index) => (
          <div key={index}>
            <div>
              {item.fullName && (
                <div
                  className="info-block"
                  style={{
                    marginTop: '5px',
                    fontSize: '13px',
                  }}
                >
                  <img
                    className="info-icon-stream --playback"
                    alt="live-stream-icon"
                    src={Info6}
                  />
                  {t('Họ tên')}: {item.fullName || ''}
                </div>
              )}
              {item.phoneNumber && (
                <div
                  className="info-block"
                  style={{
                    marginTop: '5px',
                    fontSize: '13px',
                  }}
                >
                  <img
                    className="info-icon-stream --playback"
                    alt="live-stream-icon"
                    src={Info7}
                  />
                  {t('Phone number')}: {item.phoneNumber || ''}
                </div>
              )}
            </div>
          </div>
        ))}
    </Card>
  );
};

export default DeviceInfoCard;
